module.exports = require("@graphistry/falcor-path-utils/lib/toCollapseTrees");


//////////////////
// WEBPACK FOOTER
// external "@graphistry/falcor-path-utils/lib/toCollapseTrees"
// module id = 103
// module chunks = 0